import { getWidth } from 'ol/extent';
import TileGrid from 'ol/tilegrid/TileGrid';

import { reflectInput, updateLegend } from './controls/legend'
import { saveNewLine } from './functions'
import { uploadFile } from './gps'
import {
  addEditClickHandler, closeElement,
  editableState, hideDateSelection,
  onMouseClick, selectedFeatureId, setSelectedFeatureId,
  selectedFeatureOl, setSelectedFeatureOl,
  showDoneEditingBox, switchTab
} from './helperFunctions'
import { logout } from './login'
import { closeToolbarWindow, moveTabToHome, showToolbar } from './navigation'
import { resizeMap, updateSVG } from './map/d3Renderer'
import {
  addDrawing, addMovePoint, deleteLastDrawnPoint, rehabilitateDrawing
} from './map/drawing'
import { createWMS } from './map/layers'
import {
  addGroupLayer, changeLayerOpacity, getLayerFromMapById, map, mapsToBeSteered
} from './map/tools'
import {
  closeIfEsc, closeOverview, fullScreen, helpModal, showChangesOverview
} from './qualityCheck/changesOverview'
import { filterAndLimitChangesOverview } from './qualityCheck/filter'
import {
  collection, CURRENT_GEOTYPE, debug, setHighlighted, i18n, locallyAr5,
  minDrawingZoom, minZoom
} from './storage'

export let OPERATION = '';
export const setOperation = (op) => OPERATION = op;

$('.logout').click(logout);

document.getElementById('info-box-move-button').onclick = () => {
  collection.features.forEach(feature => {
    if (feature.properties.id === selectedFeatureOl.getProperties().id) {
      feature.properties.invisible = true;
    }
  });
  addMovePoint();
};

document.getElementById('geometry-change').onclick = () => {
  if (debug < 11) console.log('Clicked geometry-change');
  if (!editableState()) return false;
  if (OPERATION === 'edit_new') return false;
  // drawInteraction.getActive() did not work, always true;
  if (OPERATION === 'add') { // console.log('already drawing');
    if (locallyAr5) document.getElementById('toolbarWindow').hidden = false;
    return;
  }
  showToolbar('draw'); // before changing operation to add
  setOperation('add');
  if (debug < 11) console.log('with OPERATION', OPERATION);
  // Remove popup on mouseover feature
  map.un('singleclick', onMouseClick);
  // reset style on previous selection, if any
  if (selectedFeatureId) {
    setHighlighted(0);
    selectedFeatureOl.setStyle(null);
    setSelectedFeatureId(null);
    setSelectedFeatureOl(null);
    updateSVG(); // to remove red style on previously selected feature
  }

  // Initialize line drawing
  // Go back to drawing modus
  if (CURRENT_GEOTYPE === 'point') addDrawing('Point');
  else addDrawing('LineString');

  // Add correct help text
  $('#info-box-text-text').empty();
  const dlht = 'draw-line-help-text';
  $('#info-box-text-text').append(
    i18n[CURRENT_GEOTYPE][locallyAr5 ? (dlht + '-ar5') : dlht].join('\n')
  );

  $('#info-box-choose-edit-type').hide();
  $('#info-box-text').show();

  $('#info-box-popup').hide();

  // Hide buttons:
  showDoneEditingBox('hide');
  regretButton.style.display = 'none';
  deleteLastDrawnPointBtn.classList.add('hidden');

  // Move tab one to the right
  switchTab('Operations', 'DrawPick');
};

// detect a change in file input
fileUpload.onchange = (e) => uploadFile(e.target.files[0]);

document.getElementById('geometry-change-by-gps').onmouseup = () => {
  // Remove popup on mouseover feature
  map.un('singleclick', onMouseClick);
};

document.getElementById('geometry-change-attributes').onclick = () => {
  if (!editableState()) return false;
  if (OPERATION === 'edit') { // editing is already active
    if (locallyAr5) toolbarWindow.hidden = false;
    return false;
  }
  showToolbar('edit'); // before changing operation to edit
  OPERATION = 'edit';
  if (debug < 10) {
    console.log('click geometry-change-attributes with OPERATION', OPERATION);
  }
  // Constrain zoom to avoid operation buttons to show while editing feature:
  map.getView().setMinZoom(minDrawingZoom);
  // Remove info popup on mouse click on feature:
  map.un('singleclick', onMouseClick);
  // Initialize click handler
  addEditClickHandler();
  // Add correct help text
  const place = document.getElementById('info-box-text-no-action-text');
  const eaht = 'edit-area-help-text' + (locallyAr5 ? '-ar5' : '');
  place.innerHTML = i18n[CURRENT_GEOTYPE][eaht].join('\n');

  $('#info-box-choose-edit-type').hide();
  $('#info-box-text-no-action').show();
  $('#info-box-popup').hide();

  // Show 'cancel' button:
  showDoneEditingBox('hide');
  regretButton.style.display = 'inline-block';

  // Move tab one to the right
  switchTab('Operations', 'DrawPick');
  resizeMap();
};

deleteLastDrawnPointBtn.onclick = () => deleteLastDrawnPoint();

regretNewLineBtn.onclick = rehabilitateDrawing;

saveNewLineBtn.onclick = () => {
  hideDateSelection();
  if (locallyAr5) document.getElementById('twdStep3').hidden = false;
  if (locallyAr5) editingCard.querySelector('.card-content').hidden = false;
  saveNewLine();
  map.getView().setMinZoom(minZoom);
};

tabHome.onclick = moveTabToHome;

// tabOperations.onclick = (e) => {
//   if(!e.target.classList.contains('disabled')) moveTabToOperations();
// };
// tabDrawPick.onclick = (e) => {
//   if(!e.target.classList.contains('disabled')) moveTabToDrawPick();
// };

window.onload = () => {
  if (locallyAr5) {
    // $('#kommuneWMS').prop('checked', true);
    // $('#kommuneWMS').change();
    kommuneWMS.click();
    setTimeout(() => kommuneWMS.click(), 100);
  }
}

export const toggleWMS = e => {
  const cb = e.target;
  mapsToBeSteered.forEach(m => {
    const pp = m.getView().getProjection().getCode();
    const mainMap = (m.getTarget() === 'map');
    const wms = getLayerFromMapById(m, cb.id);
    if (wms) wms.setVisible(cb.checked);
    else {
      // if (cb.checked) m.addLayer(specificLayer);
      let img = false;
      if (cb.checked) {
        // const wms = createWMS(cb.id).image[mainMap ? 'dynamicProjection' : pp];
        const w = createWMS(cb.id);
        if (['gnrWMS', 'kommuneWMS'].indexOf(cb.id) > -1) {
          img = true; // unngå flere like etiketter
          // ImageWMS fails with screen's size greater than 5120px
          // and TileWMS produces double text, therefore the following:
          const mapSize = m.getSize();
          if (Math.max(...mapSize) > 5120) {
            img = false;
            const tileSize = mapSize.map(s => Math.min(s, 5120));
            const extent = m.getView().getProjection().getExtent();
            const size = getWidth(extent) / tileSize[0];
            const resolutions = new Array(18);
            const rl = resolutions.length;
            for (let z = 0; z < rl; ++z) resolutions[z] = size / Math.pow(2, z);
            const tg = new TileGrid({ extent, resolutions, tileSize });
            w.tile.getSource().setTileGridForProjection('EPSG:25832', tg)
            w.tile.getSource().setTileGridForProjection('EPSG:25833', tg)
            w.tile.getSource().setTileGridForProjection('EPSG:25835', tg)
          }
        }
        const wms = (mainMap && !img) ? w.tile : w.image[pp];
        // sverigeWMS needs ticket outside NIBIO's network:
        if (cb.id === 'sverigeWMS') fetch(
          '/token/ticket_json.jsp?id=wms.lantmeteriet_topo'
        ).then(r => r.json()).then(j => {
          wms.getSource().updateParams({ TICKET: j.ticket });
          addGroupLayer(m, wms);
        });
        else addGroupLayer(m, wms);
      // } else {
      //   // else m.removeLayer(specificLayer); // it does not work if group layer
      //   if (wms) removeGroupLayer(m, wms);
      }
    }
    // AR5 13 klasser WMS change legend:
    if (['ar5_13WMS', 'arealtypeWMS'].indexOf(cb.id) > -1) {
      // const bm = document.getElementsByClassName('bg-highlight')[0];
      // const fly = (bm.id === 'flybilder');
      // // specificLayer.setVisible(fly ? false : true);
      // const k7 = getLayerById('arealtypeWMS');
      // const k13 = getLayerById('ar5_13WMS');
      // const onlyBoundaries = (k7 || k13) && fly;
      // getLayerById('ar5orthoWMS').setVisible(onlyBoundaries ? true : false);
      if (cb.checked) disableComplementary(cb.id);
      updateLegend();
    }
    // } else if (cb.id === 'ortoWMS') specificLayer.setVisible(false); // wait for project selection
  });
  // if (cb.id.indexOf('beiteWMS') > -1) {
  //   const u = document.getElementById('utenforWMS');
  //   u.checked = cb.checked;
  //   $(u).trigger('change');
  // }
};
// $('.wms').change( e => { // did not trigger dynamically created elements
$(document).on('change', '.wms', toggleWMS); // works for 'Egne WMSer' too
// document.querySelectorAll('.wms').forEach(cb => cb.onchange = toggleWMS);

// AR5 search alternatives:
document.getElementById('search_free').onclick = () => {
  event.srcElement.classList.add('searchButtons_clicked');
  document.getElementById('search_coord').classList.remove('searchButtons_clicked');
  document.getElementById('search_gps').classList.remove('searchButtons_clicked');
  document.getElementById('searchField').hidden = false;
  document.getElementById('coordinatesField').hidden = true;
  document.getElementById('gpsWindow').hidden = true;
  document.getElementById('searchInfo').innerHTML = i18n['searchInfo']['freeSearchInfo'];
};
document.getElementById('search_coord').onclick = () => {
  event.srcElement.classList.add('searchButtons_clicked');
  document.getElementById('search_free').classList.remove('searchButtons_clicked');
  document.getElementById('search_gps').classList.remove('searchButtons_clicked');
  document.getElementById('searchField').hidden = true;
  document.getElementById('coordinatesField').hidden = false;
  document.getElementById('gpsWindow').hidden = true;
  document.getElementById('searchInfo').innerHTML =  i18n['searchInfo']['coordSearchInfo'];
};
document.getElementById('search_gps').onclick = () => {
  event.srcElement.classList.add('searchButtons_clicked');
  document.getElementById('search_free').classList.remove('searchButtons_clicked');
  document.getElementById('search_coord').classList.remove('searchButtons_clicked');
  document.getElementById('searchField').hidden = true;
  document.getElementById('coordinatesField').hidden = true;
  document.getElementById('gpsWindow').hidden = false;
  document.getElementById('searchInfo').innerHTML = i18n['searchInfo']['gpsSearchInfo'];
};

const disableComplementary = (id) => {
  const cid = ['ar5_13WMS', 'arealtypeWMS'].filter(x => x !== id);
  const ccb = document.getElementById(cid);
  if (ccb.checked) ccb.click();
};

document.getElementById('x-mapLayerSelector').onclick =
  () => closeElement('mapLayerSelector');

document.getElementById('showChangesOverviewBtn').onclick = showChangesOverview;
document.getElementById('changesOverview').onkeyup = closeIfEsc;

document.getElementById('ks-close').onclick = closeOverview;
document.getElementById('ks-help').onclick = helpModal;

document.getElementById('dateSelectionCard').onsubmit = e => e.preventDefault();
document.getElementById('editingCard').onsubmit = e => e.preventDefault();

document.getElementById('northWest-resizeHandle').ondblclick = fullScreen;
document.getElementById('resizeHandle').ondblclick = fullScreen;

document.getElementById('range7').oninput = (e) => changeLayerOpacity(e);
document.getElementById('range13').oninput = (e) => changeLayerOpacity(e);
document.getElementById('range7mirror').oninput = e => reflectInput('range7', e.target.value);
document.getElementById('range13mirror').oninput = e => reflectInput('range13', e.target.value);

document.getElementById('closeToolbarWindowBtn').onclick = closeToolbarWindow;

distriktFilter.onchange = filterAndLimitChangesOverview;
kartlagFilter.onchange = filterAndLimitChangesOverview;
